(() => {
  const dialog = document.getElementById('mm-quick-buy-dialog');
  if (!dialog) return;
  const config = JSON.parse(document.getElementById('mm-quick-buy-config').textContent);
  const cache = new Map();
  const title = dialog.querySelector('h2');
  const image = dialog.querySelector('img');
  const price = dialog.querySelector('.mm-quick-buy-price');
  const option = dialog.querySelector('.mm-quick-buy-option');
  const swatches = dialog.querySelector('.mm-quick-buy-swatches');
  const status = dialog.querySelector('.mm-quick-buy-status');
  const add = dialog.querySelector('.mm-quick-buy-add');
  const link = dialog.querySelector('.mm-quick-buy-product-link');
  let trigger;
  let selected;
  let generation = 0;
  let previousOverflow = '';
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  function money(cents) {
    const format = config.moneyFormat || '{{amount_with_comma_separator}} €';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, token) => {
      const decimals = token.includes('no_decimals') ? 0 : 2;
      const locale = token.includes('comma_separator') ? 'de-DE' : 'en-US';
      return new Intl.NumberFormat(locale, {minimumFractionDigits:decimals,maximumFractionDigits:decimals}).format(cents / 100);
    }).replace(/<[^>]*>/g, '');
  }
  function priceMarkup(variant) {
    const onSale = Number(variant.compare_at_price) > Number(variant.price);
    const percent = onSale ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
    return `<span class="mm-compact-price${onSale ? ' mm-compact-price--sale' : ''}"><span class="mm-sale-current">${escape(money(variant.price))}</span>${onSale ? `<span class="mm-compare-group"><s class="mm-white-old"><span class="visually-hidden">Regulärer Preis </span>${escape(money(variant.compare_at_price))}</s>${percent > 0 ? `<sup class="mm-discount-percent">−${percent} %</sup>` : ''}</span>` : ''}</span>`;
  }
  function color(value) {
    const name = String(value).toLowerCase();
    const colors = [['weiß|weiss|white','#ffffff'],['gelb|yellow','#f5cf65'],['rosa|pink','#e8a9bc'],['grün|gruen|green','#7fb848'],['rot|red','#bf4738'],['schwarz|black','#22252a'],['blau|blue|navy|marine','#24355a'],['grau|gray|grey','#9ca3af'],['lila|purple|violet','#b294e0'],['beige|cream|creme','#f5f5dc'],['orange','#f97316'],['braun|brown','#854d0e']];
    return colors.find(([pattern]) => new RegExp(pattern).test(name))?.[1] || '#e1e6df';
  }
  function choose(product, variant) {
    selected = variant;
    price.innerHTML = priceMarkup(variant);
    option.textContent = `${product.options?.[0]?.name || 'Variante'}: ${variant.public_title || variant.title}`;
    option.hidden = product.variants.length === 1 && variant.title === 'Default Title';
    const src = variant.featured_image?.src || product.featured_image;
    image.hidden = !src;
    if (src) { image.src = src; image.alt = `${product.title} – ${variant.public_title || variant.title}`; }
    add.disabled = !variant.available;
    add.textContent = variant.available ? 'In den Warenkorb' : 'Nicht verfügbar';
    link.href = `${trigger.dataset.productUrl}?variant=${variant.id}`;
    for (const swatch of swatches.children) swatch.setAttribute('aria-pressed', String(swatch.dataset.variantId === String(variant.id)));
  }
  async function open(button) {
    const current = ++generation;
    trigger = button;
    selected = null;
    title.textContent = 'Tasse auswählen';
    price.replaceChildren();
    swatches.replaceChildren();
    option.hidden = true;
    image.hidden = true;
    add.disabled = true;
    status.textContent = 'Varianten werden geladen …';
    link.href = button.dataset.productUrl;
    if (!dialog.open) { previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; dialog.showModal(); }
    const url = new URL(button.dataset.productUrl, window.location.origin);
    url.search = '';
    url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
    try {
      if (!cache.has(url.href)) cache.set(url.href, fetch(url.href, {headers:{Accept:'application/json'}}).then(response => {if (!response.ok) throw new Error('product'); return response.json();}).catch(error => {cache.delete(url.href); throw error;}));
      const product = await cache.get(url.href);
      if (current !== generation || !dialog.open) return;
      title.textContent = product.title;
      for (const variant of product.variants) {
        if (product.variants.length === 1 && variant.title === 'Default Title') break;
        const swatch = document.createElement('button');
        swatch.type = 'button';
        swatch.className = 'mm-quick-buy-swatch';
        swatch.dataset.variantId = variant.id;
        swatch.style.setProperty('--mm-swatch', color(variant.title));
        swatch.setAttribute('aria-label', variant.public_title || variant.title);
        swatch.title = variant.public_title || variant.title;
        swatch.disabled = !variant.available;
        swatch.addEventListener('click', () => choose(product, variant));
        swatches.append(swatch);
      }
      choose(product, product.variants.find(variant => variant.available) || product.variants[0]);
      status.textContent = '';
    } catch {
      if (current === generation) status.textContent = 'Die Varianten konnten nicht geladen werden. Bitte öffne die Produktseite.';
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.('.mm-quick-buy-trigger');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    open(button);
  }, true);
  dialog.querySelector('.mm-quick-buy-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
  dialog.addEventListener('close', () => { generation++; document.body.style.overflow = previousOverflow; if (trigger?.isConnected) trigger.focus({preventScroll:true}); });
  add.addEventListener('click', async () => {
    if (!selected?.available || add.disabled) return;
    add.disabled = true;
    add.textContent = 'Wird hinzugefügt …';
    status.textContent = '';
    try {
      const response = await fetch(dialog.dataset.cartAddUrl, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:selected.id,quantity:1}],sections:['cart-drawer-section']})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Die Tasse konnte nicht hinzugefügt werden.');
      dialog.close();
      if (window.updateCartDrawerDOM && data.sections?.['cart-drawer-section']) {
        window.updateCartDrawerDOM(data.sections['cart-drawer-section']);
        const drawer = document.getElementById('cart-drawer');
        if (typeof drawer?.open === 'function') drawer.open();
        else window.location.assign(dialog.dataset.cartUrl);
      } else window.location.assign(dialog.dataset.cartUrl);
    } catch (error) { status.textContent = error.message || 'Bitte versuche es erneut.'; add.disabled = false; add.textContent = 'In den Warenkorb'; }
  });
})();
